module.exports = __webpack_public_path__ + "static/media/batutsettingsrampe.3e2c2118.svg";